import { render, staticRenderFns } from "./InfiniteDataTable.vue?vue&type=template&id=8ba73af8&scoped=true&"
import script from "./InfiniteDataTable.vue?vue&type=script&lang=js&"
export * from "./InfiniteDataTable.vue?vue&type=script&lang=js&"
import style0 from "./InfiniteDataTable.vue?vue&type=style&index=0&id=8ba73af8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba73af8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
